import barba from '@barba/core';
import views from './views';
import transitions from './transitions';
import LogoLayer from '../components/LogoLayer';
import LogoLayerDirector from '../components/LogoLayerDirector';
import ColorManager from '../components/ColorManager';
import Menu from '../components/Menu';
import Preloader from '../components/Preloader';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ShopSelection from '../components/ShopSelection';
export default class Spa {
	constructor() {
		const container = document.querySelector('[data-barba="container"]');
		barba.colorManager = new ColorManager();
		barba.colorManager.init(container);

		const preloader = new Preloader();

		const initialLogoSize = container.dataset.logoSize;
		const logoLayer = new LogoLayer();
		const director = new LogoLayerDirector(logoLayer);
		barba.logoLayerDirector = director;

		director.setTargetState('preloader');
		preloader.preload().then(() => {
			director.setTargetState(initialLogoSize);
		});

		const menuElm = document.querySelector('[data-menu]');
		barba.menu = new Menu(menuElm);

		// const shopSelects = document.querySelectorAll('[data-shop-selection]');
		// shopSelects.forEach(shopSelect => {
		new ShopSelection();
		// });

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			if (history.scrollRestoration) {
				history.scrollRestoration = 'manual';
			}

			const triggers = ScrollTrigger.getAll();
			triggers.forEach((trigger) => {
				trigger.kill();

				// Aww merr gawd.. 1 volle labs dag verder.
				// Shame.. na een dag zoeken is dit de beste oplossing. Wellicht eens kijken of dit weg kan als er een nieuwe versie van gsap/scrollTrigger is
				trigger.scroll.rec = null;
				const lelijk = setInterval(() => {
					if (trigger.scroll.rec !== null) {
						trigger.scroll.rec = null;
					}
				}, 10);
			});

			const blessEvent = new CustomEvent('bless', {
				detail: {
					element: next.container,
					trigger: trigger,
				},
			});

			document.dispatchEvent(blessEvent);

			// Reset keyboard nav to top of page
			const firstElm = document.querySelector('[data-first-element]');
			firstElm.focus();
			firstElm.blur();
		});

		barba.hooks.after(({ current, next, trigger }) => {
			document.dispatchEvent(new CustomEvent('after'));

			// Do stuff like tracking, update header, etc.
			var parser = new DOMParser();
			var htmlDoc = parser.parseFromString(next.html, 'text/html');
			const scripts = htmlDoc.getElementsByTagName('script');

			function evalInWindow(src) {
				const func = function () {
					eval(src);
				};

				//define event to prevent errors in gform javascript
				const backup = window.event;
				window.event = {};
				func.call(window);
				delete window.event;
				if (backup !== undefined) {
					window.event = backup;
				} else {
					window.event = {
						preventDefault() {},
					};
				}
			}

			[...scripts].forEach((script) => {
				if (script.hasAttribute('data-barba-include')) {
					if (script.src) {
						if (!document.querySelector(`script[src="${script.src}"]`)) {
							const scriptTag = document.createElement('script');
							scriptTag.src = script.src;
							document.head.appendChild(scriptTag);
						}
					} else {
						let src = script.innerHTML;
						try {
							console.log({ src });
							evalInWindow(src);
						} catch (e) {
							console.error(e);
						}
					}
				}
			});
		});

		// Barba settings, transitions and views
		barba.init({
			debug: false, //window.WPURLS.env == 'development' ? true : false,
			timeout: 5000,
			preventRunning: true,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}
				return false;
			},
			prevent: ({ el, event, href }) => {
				if (/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(href)) {
					return true;
				}
			},
			views: views,
			transitions: transitions,
		});
	}
}
